import { LogType } from "../../../../../../common/log_types";
import { RouterInferenceHelpers } from "../../../../../../src/api/trpc/rootRouter";

const LogTitles: Partial<Record<LogType, string>> = {
	[LogType.SettingsModify]: "Server Settings",
	[LogType.SettingsPremiumModify]: "Premium",
};

export function GuildLogTitle(props: {
	log: RouterInferenceHelpers["guild_logs"]["get"]["output"]["logs"][0];
}) {
	let title = "";
	if ("title" in props.log.data) {
		title = props.log.data.title;
	} else {
		title = LogTitles[props.log.type];
	}

	return (
		<div className="overflow-hidden overflow-ellipsis whitespace-nowrap text-sm font-bold">
			{title}
		</div>
	);
}
